import { API } from './resources'

export default {
  createPoll: (data) => {
    return API.post('/poll', data)
  },
  getCommunityPolls: (limit, offset) => {
    return API.get('/poll', { params: { limit, offset } })
  },
  getAllCommunityPolls: (limit, offset) => {
    return API.get('/poll/all', { params: { limit, offset } })
  },
  getUserResponse: (pollID) => {
    return API.get(`poll/user/option/${pollID}`)
  },
  getAllUserResponses: (pollID) => {
    return API.get(`poll/user/options/${pollID}`)
  },
  getOtherUsersResponses: (pollID, userID, projectID) => {
    return API.get(`poll/user/options/${pollID}/${userID}/${projectID}`)
  },
  saveUserOption: (data) => {
    return API.post('poll/user/option', data)
  },
  saveOtherUserOption: (userID, data) => {
    return API.post(`poll/user/option/${userID}`, data)
  },

  addOptions: (pollID, data) => {
    return API.post(`poll/${pollID}/options`, data)
  },
  updatePoll: (pollID, data) => {
    return API.put(`poll/${pollID}`, data)
  },
  getPollUserOptionSummaries: (projectId) => {
    return API.get(`/poll/useroptionsummaries/${projectId}`)
  },
  getPollUserOptions: (projectId) => {
    return API.get(`/poll/user/project?projectIDs=${projectId}`)
  },
  getPollQuestions: (projectId) => {
    return API.get(`/poll/project?projectIDs=${projectId}`)
  },
  getPollQuestionsFilter: (projectIds) => {
    return API.get(`/poll/filter?projectIDs=${projectIds.join(',')}`)
  }
}
